import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { FaExclamationCircle } from 'react-icons/fa';

import { UseOutletContextInventory } from '../Inventory';
import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { uploadTooltip } from '../../../../utils/tooltip.util';

import AppInputAccountingAccount from '../../../../components/element/InputAccountingAccount';

export interface AppInventoryFormAccountingAccountProps {
  component?: string,
  accounts: {value: {expense: string, vat: string, income: string}, valid: {expense: boolean, vat: boolean, income: boolean}},
  setAccounts: Dispatch<SetStateAction<{value: {expense: string, vat: string, income: string}, valid: {expense: boolean, vat: boolean, income: boolean}}>>
};

const AppInventoryFormAccountingAccount: React.FunctionComponent<AppInventoryFormAccountingAccountProps> = ({component, accounts, setAccounts}) => {
  const {companyForUser, accountingExpenseAccountsForCompany, accountingVatAccountsForCompany, accountingIncomeAccountsForCompany} = UseOutletContextInventory()
  const {lang} = StateLanguage()

  useEffect( () => {
    uploadTooltip()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyForUser, accountingExpenseAccountsForCompany, accountingVatAccountsForCompany, accountingIncomeAccountsForCompany])

  return (
    <>
      { companyForUser && accountingExpenseAccountsForCompany && accountingVatAccountsForCompany && accountingIncomeAccountsForCompany &&
        <>
          <div className="fv-row mb-3">
            <label className="form-label">
              <div className="d-flex align-items-center">
                <span className="required">{lang.labels.expenseAccount}</span>
                <i className="ms-2 fs-8" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-original-title={lang.labels.accountingAccountPurchases}><FaExclamationCircle /></i>
              </div>
            </label>
            <AppInputAccountingAccount component={component} options={{small: false, type: "expense", index: null, item: null}} companyForUser={companyForUser} accountingExpenseAccountsForCompany={accountingExpenseAccountsForCompany} accountingIncomeAccountsForCompany={accountingIncomeAccountsForCompany} accountingVatAccountsForCompany={accountingVatAccountsForCompany} accounts={accounts} setAccounts={setAccounts}></AppInputAccountingAccount>
          </div>
          <div className="fv-row mb-3">
            <label className="form-label">
              <div className="d-flex align-items-center">
                <span className="required">{lang.labels.vatAccount}</span>
                <i className="ms-2 fs-8" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-original-title={lang.labels.accountingAccountPurchases}><FaExclamationCircle /></i>
              </div>
            </label>
            <AppInputAccountingAccount component={component} options={{small: false, type: "vat", index: null, item: null}} companyForUser={companyForUser} accountingExpenseAccountsForCompany={accountingExpenseAccountsForCompany} accountingIncomeAccountsForCompany={accountingIncomeAccountsForCompany} accountingVatAccountsForCompany={accountingVatAccountsForCompany} accounts={accounts} setAccounts={setAccounts}></AppInputAccountingAccount>
          </div>
          <div className="fv-row">
            <label className="form-label">
              <div className="d-flex align-items-center">
                <span className="required">{lang.labels.accountProduct}</span>
                <i className="ms-2 fs-8" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-original-title={lang.labels.accountingAccountSales}><FaExclamationCircle /></i>
              </div>
            </label>
            <AppInputAccountingAccount component={component} options={{small: false, type: "income", index: null, item: null}} companyForUser={companyForUser} accountingExpenseAccountsForCompany={accountingExpenseAccountsForCompany} accountingIncomeAccountsForCompany={accountingIncomeAccountsForCompany} accountingVatAccountsForCompany={accountingVatAccountsForCompany} accounts={accounts} setAccounts={setAccounts}></AppInputAccountingAccount>
          </div>
        </>
      }
    </>
  )
};

export default AppInventoryFormAccountingAccount;
